import React, { useState } from 'react';
import './HelpdeskForm.scss';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import Section from './Section';
import SectionHeader from './SectionHeader';

function HelpdeskForm(props) {
  const [user] = useState('');
  const [submittedBy, setSubmittedBy] = useState('');
    const [email, setEmail] = useState(user.email || '');
    const [organization, setOrganization] = useState('');
    const [issueTitle, setIssueTitle] = useState('');
    const [issueCategory, setIssueCategory] = useState('Bug'); // Default value
    const [issueDesc, setIssueDesc] = useState('');
    const [sampleCode, setSampleCode] = useState('');
    const [message, setMessage] = useState(null);

    const handleSubmit = async (e) => {
      e.preventDefault();
    
      const botUsername = 'pds-helpdesk-bot';
      const accessToken = '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';
      const repoOwner = 'gdayreiss';
      const repoName = 'pds-helpdesk-test';
      const issueLabels = ['helpdesk', 'needs-review', issueCategory.toLowerCase(), organization.toLowerCase()]; // Add the selected category as a label
      const issueBody = `
    
    ## Ticket Information
    - **Name:** ${submittedBy}
    - **Company:** ${organization}
    - **Email:** ${email}
    - **Issue Category:** ${issueCategory}
    
    ## Description
    ${issueDesc}
    
    ## Sample Code
    ${sampleCode}
      `;
    
      try {
        const response = await fetch(`https://api.github.com/repos/${repoOwner}/${repoName}/issues`, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json', // Set the content type to JSON
          },
          body: JSON.stringify({
            title: issueTitle,
            body: issueBody,
            labels: issueLabels,
            assignees: [botUsername, 'gdayreiss'],
          }),
        });
    
        if (response.ok) {
          const responseData = await response.json();
          console.log('Response status:', response.status);
          console.log('Response data:', responseData);
    
          const issueURL = responseData.html_url;
          console.log('Ticket created successfully');
          setMessage(
            <p>
              Ticket created successfully. View the issue{" "}
              <a href={issueURL}>here</a>.
            </p>
          );
          setTimeout(() => {
            window.location.reload(); // Refresh the page
          }, 15000);
          // Reset form fields or provide success feedback to the user
        } else {
          console.error('Ticket submission failed');
          // Display error message to the user
        }
      } catch (error) {
        console.error('API request error:', error);
        setMessage('Ticket submission failed');
        // Handle API request error
      }
    };
    
    return (
    
    <Section
    color={props.color}
    size={props.size}
    backgroundImage={props.backgroundImage}
    backgroundImageOpacity={props.backgroundImageOpacity}
    >
    
    <div className="container">
      <div style={{ width: "500px", height:"auto", marginLeft: "36%" }}>
        <img src="pds-portfolio-loading-animation.gif" alt="Illustration" />
      </div>
      <SectionHeader
        title={props.title}
        subtitle={props.subtitle}
        size={1}
        spaced={true}
        className="has-text-centered"
      />
      <div className="App">
        <div className="form-container">
          <br>
          </br>
          <div className="box" style={{width:"50%", marginLeft: "15%", marginBottom:"5%", border: "1px solid #D6D4D4"}}>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="submittedBy">Name</label>
              <input
                type="text"
                id="submittedBy"
                value={submittedBy}
                onChange={(e) => setSubmittedBy(e.target.value)}
                required
              />
            </div>
            <br></br>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="text"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <br></br>
            <div className="form-group">
              <label htmlFor="organization">Organization</label>
              <input
                type="text"
                id="organization"
                value={organization}
                onChange={(e) => setOrganization(e.target.value)}
                required
              />
            </div>
            <br></br>
            <div className="form-group">
              <label htmlFor="issueTitle">Title</label>
              <input
                type="text"
                id="issueTitle"
                value={issueTitle}
                onChange={(e) => setIssueTitle(e.target.value)}
                required
              />
            </div>
            <br></br>
            <div className="form-group">
              <label htmlFor="issueCategory">Category</label>
              <select
                id="issueCategory"
                value={issueCategory}
                onChange={(e) => setIssueCategory(e.target.value)}
                required
              >
                <option value="Bug">Bug</option>
                <option value="Question">Question</option>
                <option value="API">API</option>
                <option value="Licenses">Licenses</option>
                <option value="Documentation">Documentation</option>
              </select>
            </div>
            <br></br>
            <div className="form-group">
              <label htmlFor="issueDesc">Description</label>
              <textarea
                id="issueDesc"
                value={issueDesc}
                onChange={(e) => setIssueDesc(e.target.value)}
                required
              />
            </div>
            <br></br>
            <div className="form-group">
              <label htmlFor="sampleCode">Sample Code</label>
              <textarea
                id="sampleCode"
                value={sampleCode}
                onChange={(e) => setSampleCode(e.target.value)}
              />
            </div>
            <br></br>
            <button className="button is-3 is-primary" type="submit">Submit Ticket</button>
            {message && <p className={message === 'Ticket created successfully.' ? 'success' : 'error'}>{message}</p>}
            <div></div>
          </form>
        </div>
      </div>
    </div>
  </div>
  </Section>
    
    );
  }

export default HelpdeskForm;
